import { useQuery } from '@tanstack/react-query';
import { Api } from '../api';
import useIsClientAdmin from './useIsClientAdmin';

interface CaseRefValidator {
  client_code: string;
  rule_code: string;
  field_max_length: number;
  regex: string;
  nhs_number_flag: boolean;
  sample_data: string;
  error_text: string;
}

interface CaseRefValidation {
  validateCaseRef: (caseRef: string) => boolean;
  errorText: null | string;
}

export const useValidateCaseRef = (patientGuid: string): CaseRefValidation => {
  const isClientAdmin = useIsClientAdmin();

  const { data: caseRefValidatorMeta } = useQuery<CaseRefValidator>({
    queryKey: ['caseRefValidatorMeta', patientGuid],
    queryFn: async () => {
      const res = await Api.meta.getCaseRefValidation(patientGuid);
      return res.data.meta[0].field_validators[0];
    },
    enabled: !isClientAdmin && !!patientGuid
  });

  const validateCaseRef = (caseRef: string) => {
    if (caseRefValidatorMeta?.regex) {
      const caseRefValidator = new RegExp(caseRefValidatorMeta.regex);
      // BE not able to use case-insensitive regex, so we need to convert caseRef to upper case (which is done anyway in the BE)
      return caseRefValidator.test(caseRef.toUpperCase());
    }
    return true;
  };
  return {
    validateCaseRef: validateCaseRef,
    errorText: caseRefValidatorMeta?.error_text || 'Please enter a valid case reference'
  };
};
